<script lang="ts" setup>
import { onMounted, ref } from "vue";
import { usePopular } from "@/stores/popular";
import TagItem from "@/components/mobile/common/TagItem.vue";

const props = withDefaults(
  defineProps<{
    max: number;
    wrap?: boolean;
  }>(),
  {
    max: 10,
    wrap: true,
  }
);
const emit = defineEmits<{
  (e: "onTagSelect", tag: string): void;
}>();

const popular = usePopular();
</script>
<template>
  <div
    v-if="!popular.loadingMateTags"
    :class="{
      'flex-wrap': wrap,
      'flex-nowrap': !wrap,
    }"
    class="flex gap-1"
  >
    <TagItem
      v-for="(item, idx) in popular.mateTagList.slice(0, max)"
      :key="idx"
      :label="`${item.tag}(${item.count})`"
      @click="emit('onTagSelect', item.tag)"
    />
  </div>
  <div v-else class="loading loading-sm" />
</template>
